import { flatNestedRoutes } from '@pages/routes/route-helper';
import { appPublicRoutes } from '@pages/routes/route-public';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const stylesheetId = 'grecaptcha-toggle-style';

const normalizePath = (path: string) => {
  if (path === '/') return path;
  return path.replace(/\/+$/, '');
};

const toggleBadgeStyleSheet = (publicPaths: string[], currentPath: string) => {
  let style = document.getElementById(stylesheetId) as HTMLStyleElement;

  if (!style) {
    style = document.createElement('style');
    style.id = stylesheetId;
    document.head.appendChild(style);
  }

  const isPublic = publicPaths.includes(normalizePath(currentPath));

  style.innerHTML = isPublic
    ? `.grecaptcha-badge { visibility: visible !important; }`
    : `.grecaptcha-badge { visibility: hidden !important; }`;
};

export default function RecaptchaBadgeToggle() {
  const flatPublicRoutes = flatNestedRoutes(appPublicRoutes);
  const location = useLocation();
  const publicPaths = flatPublicRoutes.map((r) => normalizePath(r.path));

  useEffect(() => {
    toggleBadgeStyleSheet(publicPaths, location.pathname);
  }, [location.pathname, publicPaths]);

  return null;
}
